import { PermissionCheckTargetField, DocumentType } from '../../api'
import { getAllEnumOptions } from '../enum'

export const getAllPermissionCheckTargetFields = () =>
  getAllEnumOptions(PermissionCheckTargetField)

export const getAllPermissionCheckTargetFieldsForDocumentType = (
  documentType: DocumentType,
) => {
  var options = [
    PermissionCheckTargetField.DocumentId,
    PermissionCheckTargetField.DocumentExternalId,
  ]
  if (documentType === DocumentType.Incident)
    options = [
      PermissionCheckTargetField.DocumentId,
      PermissionCheckTargetField.DocumentExternalId,
      PermissionCheckTargetField.IncidentNumber,
    ]
  else if (documentType === DocumentType.EmergencyResource)
    options = [
      PermissionCheckTargetField.DocumentId,
      PermissionCheckTargetField.DocumentExternalId,
      PermissionCheckTargetField.UnitIdentification,
    ]

  const test = Object.keys(PermissionCheckTargetField).filter(key => {
    return !isNaN(parseInt(key)) && options.indexOf(parseInt(key)) > -1
  })
  return test.map(key => ({
    key,
    label: PermissionCheckTargetField[key as any],
    value: key,
  }))
}

export const getDefaultPermissionCheckTargetFieldForDocumentType = (
  documentType: DocumentType,
) => {
  if (documentType === DocumentType.Incident)
    return PermissionCheckTargetField.IncidentNumber
  else if (documentType === DocumentType.EmergencyResource)
    return PermissionCheckTargetField.UnitIdentification
  return PermissionCheckTargetField.DocumentExternalId
}

export const getPermissionCheckTargetFieldLabel = (
  key?: PermissionCheckTargetField,
) => {
  if (key === null || typeof key === 'undefined') return ''

  return PermissionCheckTargetField[key]
}
